import React from 'react';
import { FormattedDate, FormattedTime } from 'react-intl';
import classNames from 'classnames';

import { LOG_LEVEL } from '../../constants';
import { JobLogResponse } from '../../openapi/types';

export type LogItemProps = {
  content: string;
  date: string;
  id: number;
  jobId: number;
  level: number;
};

export const LogListItem: React.FC<JobLogResponse> = (props) => {
  return (
    <tr>
      <td
        className={classNames({
          'sg-a-w-1px': true,
          'dmx-u-stateColumn': true,
          [`dmx-logList--level-${props.level}`]: !!props.level,
        })}
        title={props.level && LOG_LEVEL[props.level]}
      />
      <td className='sg-a-va-b sg-a-ta-r sg-u-type-bold sg-a-fvn-tn'>#{props.id}</td>
      <td className='sg-a-va-b sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
        {props.date && (
          <time className='sg-u-type-sml sg-u-c-body-darkest' dateTime={props.date}>
            <FormattedDate value={new Date(props.date)} />{' '}
            <FormattedTime
              value={new Date(props.date)}
              hour='numeric'
              minute='numeric'
              second='numeric'
            />
          </time>
        )}
      </td>
      <td className='sg-a-va-b'>
        <pre className='sg-u-type-xsm sg-a-ws-pw'>{props.content}</pre>
      </td>
    </tr>
  );
};
